import React, { useContext, useEffect, useMemo } from 'react'
import { useParams } from 'react-router-dom'
import useSWR from 'swr'
import { Public_Single_Section, Shared_Single_Section } from '@graphql/queries'
import SideBarPage from '@views/SideBarPage'
import Loader from '@components/Loader'
import SideBar from '@components/SideBar'
import ContentHeader from '@components/ContentHeader'
import SectionRenderer from '@components/SectionRenderer'
import { setCurrentSection } from '@state/actions/appActions'
import { AppContext } from '@state/context'

const SingleSection = () => {
  const { id, shareLink } = useParams()
  const [state, dispatch] = useContext(AppContext)
  const { currentSection } = state?.app
  const { data, error, isValidating } = useSWR([id ? Public_Single_Section : Shared_Single_Section, id ? id : { shareLink }])

  useEffect(() => {
    if (data && !error) {
      dispatch(setCurrentSection(data?.section))
    }
    // if (!isValidating && !error && !data?.publicSection) {
    //   window.location.replace('/login')
    // }
  }, [data, error, isValidating])
  const breadcrumb = useMemo(() => (currentSection && {
    label: currentSection?.name,
  }), [currentSection])

  return (
    <SideBarPage>
      <SideBar breadcrumb={breadcrumb} >
        {isValidating && !error && <Loader />}
        {error && <p>Något gick fel när avsnittet skulle laddas</p>}
      </SideBar>

      {/* main area */}
      <SideBarPage.Content>
        {isValidating && !error && <Loader />}
        {error && <p>Något gick fel när avsnittet skulle laddas</p>}

        {currentSection && !error && (
          <>
            <ContentHeader />
            <SectionRenderer section={currentSection} />
          </>
        )}
      </SideBarPage.Content>
    </SideBarPage>
  )
}

export default SingleSection
